import { Compass, Cpu, UploadCloud, FileText, CalendarClock, Activity, CreditCard, Package } from "lucide-react";

const features = [
  { icon: Compass, bg: "from-indigo-500 to-purple-600", title: "Discover Facilities", desc: "Browse 12 centres across Andhra Pradesh with map view." },
  { icon: Cpu, bg: "from-sky-400 to-blue-500", title: "Explore Machines", desc: "340+ machines with real-time availability & specs." },
  { icon: UploadCloud, bg: "from-sky-400 to-cyan-500", title: "Upload CAD & Design", desc: "STL, STEP, IGES, DWG, DXF, PDF & BOM." },
  { icon: FileText, bg: "from-fuchsia-500 to-pink-600", title: "Instant Quotations", desc: "AI-assisted cost estimates within 24 hours." },
  { icon: CalendarClock, bg: "from-orange-400 to-rose-500", title: "Book Machines & Experts", desc: "Live calendar booking with operator allocation." },
  { icon: Activity, bg: "from-purple-500 to-fuchsia-600", title: "Track Prototype Progress", desc: "Real-time timeline from CAD to delivery." },
  { icon: CreditCard, bg: "from-indigo-500 to-blue-600", title: "Manage Payments", desc: "UPI, cards & net-banking with milestone billing." },
  { icon: Package, bg: "from-teal-400 to-cyan-500", title: "Prototype Delivery", desc: "QR-tracked dispatch with proof of delivery." },
];

export default function Features() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-5">

  <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 max-w-2xl">
    How ProtoHub {" "}
    <span className="bg-gradient-to-r from-indigo-600 to-blue-500 bg-clip-text text-transparent">
      works
    </span>
  </h2>
  <p className="text-gray-600 max-w-xl mb-12">
    From discovery to delivery — a complete digital operating system
    for advanced prototyping.
  </p>

  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
    {features.map(({ icon: Icon, bg, title, desc }) => (
      <div
        key={title}
        className="border border-gray-100 rounded-2xl p-6 hover:shadow-lg transition"
      >
        <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${bg} flex items-center justify-center mb-4`}>
          <Icon className="w-5 h-5 text-white" />
        </div>
        <h3 className="font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-600">{desc}</p>
      </div>
    ))}
  </div>
</section>
  );
}